/**
 * Maps admin FAQ form category labels to FAQ.js browse slugs (CATEGORY_META keys).
 */
const LABEL_TO_SLUG = {
  'Time Tracking': 'time',
  'Jobs & Assignments': 'jobs',
  Payments: 'payments',
  Reports: 'reports',
  'Account Settings': 'account',
};

export function categoryLabelToFaqSlug(label) {
  const key = String(label || '').trim();
  return LABEL_TO_SLUG[key] || 'account';
}
